import IWidget from './iwidget';

export class WidgetException extends Error {
    public widget: IWidget;

    public reason: string;

    public severity: string;

    /**
     *
     * @param widget
     * @param reason
     * @param severity
     */
    constructor(widget: IWidget, reason = '', severity = '') {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(reason);

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        // @ts-ignore
        if (Error.captureStackTrace) Error.captureStackTrace(this, WidgetException);

        this.widget = widget;
        this.reason = reason;
        this.severity = severity;
    }
}
